import React from 'react';

import PropTypes from 'prop-types';

import { Asset } from 'components/Asset';
import {
  StyledGenderButton,
  StyledIconWrapper,
  StyledButtonWrapper,
} from 'components/GenderButtons/styles';
import FieldGroup from 'components/PortalFormFields/FieldGroup';
import {
  GENDER_MAN,
  GENDER_WOMAN,
  COMPANY_DETAILS_GENDER__MAN,
  COMPANY_DETAILS_GENDER__WOMAN,
} from 'modules/Inquiry/Form/formFields';
import { FinalFormFieldPropTypes } from 'utils/form/propTypes';
import withFormField from 'utils/form/withFormField';
import { useTranslations } from 'utils/hooks/useTranslations';

const GenderButtons = ({ value, onChange, label, error, name, disabled = false }) => {
  const t = useTranslations(
    'pages.companyDetails.sections.contactPerson.fields.companyDetailsGender.genders',
  );

  const handleGenderClick = (genderValue) => () => onChange(genderValue);
  return (
    <FieldGroup label={label} error={error} labelId="gender-button-group-label">
      <StyledButtonWrapper data-testid={name}>
        <StyledGenderButton
          data-testid={COMPANY_DETAILS_GENDER__WOMAN}
          type="button"
          name={name}
          className={value === GENDER_WOMAN && 'active'}
          onClick={handleGenderClick(GENDER_WOMAN)}
          disabled={disabled}
          aria-labelledby="gender-button-group-label gender-woman-button-label"
        >
          <StyledIconWrapper>
            <Asset type="gender" value={COMPANY_DETAILS_GENDER__WOMAN} boxSize="8" />
          </StyledIconWrapper>
          <span id="gender-woman-button-label">{t('woman')}</span>
        </StyledGenderButton>

        <StyledGenderButton
          data-testid={COMPANY_DETAILS_GENDER__MAN}
          type="button"
          className={value === GENDER_MAN && 'active'}
          onClick={handleGenderClick(GENDER_MAN)}
          disabled={disabled}
          aria-labelledby="gender-button-group-label gender-man-button-label"
        >
          <StyledIconWrapper>
            <Asset type="gender" value={COMPANY_DETAILS_GENDER__MAN} boxSize="8" />
          </StyledIconWrapper>
          <span id="gender-man-button-label">{t('man')}</span>
        </StyledGenderButton>
      </StyledButtonWrapper>
    </FieldGroup>
  );
};

GenderButtons.defaultProps = {
  value: null,
  error: null,
  name: null,
};

GenderButtons.propTypes = {
  value: PropTypes.oneOf([GENDER_MAN, GENDER_WOMAN, '']),
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  error: PropTypes.string,
  name: PropTypes.string,
};

const GenderAdapter = ({ input, meta, ...rest }) => (
  <GenderButtons
    value={input.value}
    onChange={input.onChange}
    error={meta.touched ? meta.error : ''}
    label={rest.caption}
    name={input.name}
    {...rest}
  />
);
GenderAdapter.propTypes = FinalFormFieldPropTypes;

export const GenderWithField = withFormField(GenderAdapter);
